import PrivateRoomsGrid from "./PrivateRoomsGrid";

export default PrivateRoomsGrid;
